module.exports = __webpack_public_path__ + "static/img/heyWhale_index_icon03.5ea159e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heyWhale_index_icon03.png
// module id = 7imR
// module chunks = 0